<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size:15px; font-weight: bold">update shiippingline</small>
      </legend>
      <div>
        <form @submit.prevent="shippinglineUpdate()">
          <input type="hidden" class="id" :value="Shippingline.id" />
          <div class="form-group">
            <label>Shipping line</label>
            <input
              type="text"
              class="form-control shipping_name input-rounded f-s-14"
              :value="Shippingline.shipping_name"
              placeholder="shipping line name"
              required
            />
          </div>
          <div class="form-group">
            <label>Free days</label>
            <input
              type="number"
              class="form-control free_days input-rounded f-s-14"
              :value="Shippingline.free_days"
              placeholder="fre days"
              required
            />
          </div>
          <div class="form-group">
            <label>OOG days</label>
            <input
              type="number"
              class="form-control oog input-rounded f-s-14"
              placeholder="oog days"
              :value="Shippingline.oog"
              required
            />
          </div>
          <button type="submit" class="btn btn-primary btn-flat updatingShippingline btn-rounded">
            <i class="fa fa-refresh"></i> update shippingline
          </button>
          <button type="button" class="btn btn-info btn-flat updatingShippinglineLoader btn-rounded">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import router from "../router/index";
export default {
  created() {
    if (this.$store.getters.Shippingline.length === 0) {
      router.push("/manageshippinglines");
    }
  },
  computed: {
    ...mapGetters(["Shippingline"])
  },
  methods: {
    ...mapActions(["shippinglineUpdate"])
  }
};
</script>
<style scoped>
.updatingShippinglineLoader {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/shippinglines/updateshippingline.vue